'use client';

// ─────────────────────────────────────────────────────────────────────────────
// DocumentsTab — paperwork + quick contacts surface.
//
// Composes:
//   1. QuickAccessWidget — internal sub-tabs: Documents / Speed Dial /
//      Milestones. Owns its own fetch.
//   2. Photo Approvals quick link — previously a small chip in the top app
//      bar; promoted to a full card here since photo review is a
//      documents-bucket workflow.
//
// Document upload + change orders + contracts cards are placeholders for
// future PRs — surfaced here so the tab has presence even before those
// flows are wired up.
// ─────────────────────────────────────────────────────────────────────────────

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import QuickAccessWidget from '../QuickAccessWidget';

interface DocumentsTabProps {
  onJobDetail: () => void;
}

export default function DocumentsTab({ onJobDetail }: DocumentsTabProps) {
  return (
    <div className="space-y-5">
      <div className="min-h-[420px]">
        <QuickAccessWidget />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Link
          href="/photo-gallery-approval-workflow-system"
          className="flex items-center justify-between bg-card border border-border rounded-xl px-5 hover:border-primary hover:shadow-sm transition-standard press-scale"
          style={{ minHeight: '64px' }}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(16,185,129,0.1)' }}>
              <Icon name="PhotoIcon" size={20} style={{ color: '#10B981' }} variant="solid" />
            </div>
            <div className="text-left">
              <p className="font-body text-sm font-semibold text-foreground">Photo Approvals</p>
              <p className="font-caption text-xs text-muted-foreground">Review crew-uploaded photos</p>
            </div>
          </div>
          <Icon name="ArrowRightIcon" size={16} className="text-muted-foreground" />
        </Link>

        <button
          onClick={onJobDetail}
          className="flex items-center justify-between bg-card border border-border rounded-xl px-5 hover:border-primary hover:shadow-sm transition-standard press-scale"
          style={{ minHeight: '64px' }}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(245,158,11,0.1)' }}>
              <Icon name="ClipboardDocumentListIcon" size={20} style={{ color: '#F59E0B' }} variant="solid" />
            </div>
            <div className="text-left">
              <p className="font-body text-sm font-semibold text-foreground">Job Detail</p>
              <p className="font-caption text-xs text-muted-foreground">Open job paperwork &amp; details</p>
            </div>
          </div>
          <Icon name="ArrowRightIcon" size={16} className="text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
